import React from "react";
import { motion, useMotionValue, useTransform } from "framer-motion";

export default function TiltCard({ children, className = "card", style, intensity = 8 }) {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useTransform(y, [-40, 40], [intensity, -intensity]);
  const rotateY = useTransform(x, [-40, 40], [-intensity, intensity]);

  const handleMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    x.set(e.clientX - rect.left - rect.width / 2);
    y.set(e.clientY - rect.top - rect.height / 2);
  };
  const handleLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.div
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      style={{ rotateX, rotateY, transformStyle: "preserve-3d", transformPerspective: 900, ...style }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
